<div class="card mt-3">
  <div class="card-header d-flex align-items-center justify-content-between">
    <div class="fw-bold">Footer (მართვა)</div>

    <button class="btn btn-sm btn-outline-primary" (click)="loadSections()">
      განახლება
    </button>
  </div>

  <div class="card-body">
    <div class="row g-3">

      <!-- LEFT: Sections -->
      <div class="col-lg-4">
        <div class="mb-2 fw-semibold">სექციები</div>

        <div class="input-group mb-2">
          <input class="form-control" [(ngModel)]="newSectionTitle" placeholder="ახალი სექციის სათაური..." />
          <button class="btn btn-primary" (click)="addSection()">დამატება</button>
        </div>

        <div *ngIf="loadingFooter" class="text-muted small">იტვირთება...</div>

        <div class="list-group" *ngIf="!loadingFooter">
          <div
            class="list-group-item d-flex justify-content-between align-items-center"
            *ngFor="let s of sections; let i = index"
            [class.active]="selectedSectionId === s.id"
            style="cursor:pointer;"
            (click)="selectSection(s.id)"
          >
            <div>
              <div class="fw-semibold">{{ s.title }}</div>
              <div class="small opacity-75">ID: {{ s.id }}</div>
            </div>

            <div class="d-flex gap-1" (click)="$event.stopPropagation()">
              <button class="btn btn-sm btn-light" (click)="moveSection(true,i)" title="ზემოთ">↑</button>
              <button class="btn btn-sm btn-light" (click)="moveSection(false,i)" title="ქვემოთ">↓</button>

              <button class="btn btn-sm btn-outline-secondary" (click)="toggleSectionVisible(s)">
                {{ s.visible == 1 ? 'ჩანს' : 'დამალულია' }}
              </button>

              <button class="btn btn-sm btn-outline-danger" (click)="deleteSection(s)">✕</button>
            </div>
          </div>

          <div *ngIf="!sections.length" class="text-muted small mt-2">სექციები არ არის</div>
        </div>
      </div>

      <!-- RIGHT: Selected section + Items -->
      <div class="col-lg-8">
        <div *ngIf="!selectedSection" class="text-muted">
          აირჩიე სექცია მარცხნიდან.
        </div>

        <div *ngIf="selectedSection" class="border rounded p-3">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div>
              <div class="fw-bold">სექცია: {{ selectedSection.title }}</div>
              <div class="text-muted small">ID: {{ selectedSection.id }}</div>
            </div>
          </div>

          <!-- Edit section title -->
          <div class="input-group mb-3">
            <input class="form-control" [(ngModel)]="selectedSection.title" />
            <button class="btn btn-outline-primary" (click)="saveSectionTitle()">შენახვა</button>
          </div>

          <hr />

          <!-- Add item -->
          <div class="fw-semibold mb-2">ელემენტის დამატება</div>
          <div class="row g-2 align-items-end">
            <div class="col-md-3">
              <label class="form-label small">Type</label>
              <select class="form-select" [(ngModel)]="newItem.type">
                <option value="text">text</option>
                <option value="phone">phone</option>
                <option value="email">email</option>
                <option value="address">address</option>
                <option value="hours">hours</option>
                <option value="link">link</option>
                <option value="social">social</option>
              </select>
            </div>

            <div class="col-md-3">
              <label class="form-label small">Label</label>
              <input class="form-control" [(ngModel)]="newItem.label" placeholder="მაგ: საერთო კონტაქტი" />
            </div>

            <div class="col-md-3">
              <label class="form-label small">Value</label>
              <input class="form-control" [(ngModel)]="newItem.value" placeholder="ტექსტი / ტელეფონი / მეილი..." />
            </div>

            <div class="col-md-3">
              <label class="form-label small">URL (link/social)</label>
              <input class="form-control" [(ngModel)]="newItem.url" placeholder="https://..." />
            </div>

            <div class="col-md-3">
              <label class="form-label small"><a target="_blank" href="https://www.flaticon.com/search/2?type=uicon">Icon (optional)</a></label>
              <input class="form-control" [(ngModel)]="newItem.icon" placeholder="facebook / youtube / fi-rr..." />
            </div>

            <div class="col-md-3">
              <label class="form-label small">Target</label>
              <select class="form-select" [(ngModel)]="newItem.target">
                <option [ngValue]="0">იმავე ფანჯარაში</option>
                <option [ngValue]="1">ახალ ფანჯარაში</option>
              </select>
            </div>

            <div class="col-md-3">
              <label class="form-label small">Visible</label>
              <select class="form-select" [(ngModel)]="newItem.visible">
                <option [ngValue]="1">ჩანს</option>
                <option [ngValue]="0">დამალულია</option>
              </select>
            </div>

            <div class="col-md-3">
              <button class="btn btn-primary w-100" (click)="addItem()">დამატება</button>
            </div>
          </div>

          <hr class="my-3" />

          <!-- Items list -->
          <div class="fw-semibold mb-2">ელემენტები</div>

          <div class="table-responsive" *ngIf="items?.length; else noItems">
            <table class="table table-sm table-bordered align-middle">
              <thead>
                <tr>
                  <th style="width:50px;">#</th>
                  <th style="width:120px;">Type</th>
                  <th>Label</th>
                  <th>Value</th>
                  <th>URL</th>
                  <th style="width:140px;">Target</th>
                  <th style="width:160px;">ქმედება</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let it of items; let i = index">
                  <td>{{ i+1 }}</td>
                  <td><code>{{ it.type }}</code></td>

                  <td>
                    <input class="form-control form-control-sm" [(ngModel)]="it.label" (blur)="saveItem(it)" />
                  </td>

                  <td>
                    <input class="form-control form-control-sm" [(ngModel)]="it.value" (blur)="saveItem(it)" />
                  </td>

                  <td>
                    <input class="form-control form-control-sm" [(ngModel)]="it.url" (blur)="saveItem(it)" />
                  </td>

                  <td class="small">
                    <select class="form-select form-select-sm" [(ngModel)]="it.target" (change)="saveItem(it)">
                      <option [ngValue]="0">იმავე</option>
                      <option [ngValue]="1">ახალ ფანჯარაში</option>
                    </select>
                  </td>

                  <td>
                    <div class="d-flex gap-1">
                      <button class="btn btn-sm btn-light" (click)="moveItem(true,i)">↑</button>
                      <button class="btn btn-sm btn-light" (click)="moveItem(false,i)">↓</button>

                      <button class="btn btn-sm btn-outline-secondary" (click)="toggleItemVisible(it)">
                        {{ it.visible == 1 ? 'ჩანს' : 'დამალულია' }}
                      </button>

                      <button class="btn btn-sm btn-outline-danger" (click)="deleteItem(it)">✕</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="text-muted small">
              Target: 0 = იმავე ფანჯარაში, 1 = ახალ ფანჯარაში
            </div>
          </div>

          <ng-template #noItems>
            <div class="text-muted small">ელემენტები ჯერ არ არის</div>
          </ng-template>

        </div>
      </div>

    </div>
  </div>
</div>